import React, { useEffect, useState, Suspense } from 'react'
import styled from 'styled-components'
import TitleHeader from 'components/presenters/header/TitleHeader'
import LoadingModal from 'components/presenters/modal/LoadingModal'
import { getQueryStringObject } from 'utils/utils.js'

export default function MypageSettingNotice() {
  const [defaultOpenNo, setDefaultOpenNo] = useState(null)
  useEffect(() => {
    let queryString = getQueryStringObject()

    if (queryString['open_no']) {
      setDefaultOpenNo(parseInt(queryString['open_no']))
    }
  }, [])
  const Notice4 = React.lazy(() => import('components/presenters/notice/Notice4'))
  const Notice3 = React.lazy(() => import('components/presenters/notice/20220714'))
  const Notice2 = React.lazy(() => import('components/presenters/notice/20220112'))
  const Notice1 = React.lazy(() => import('components/presenters/notice/20211217'))
  const Data = [
    {
      no: 4,
      listname: '모티너스 포인트 소멸 정책 안내',
      day: '2023/06/06',
      cont: (
        <Suspense fallback={<LoadingModal zIndex={500} />}>
          <Notice4 />
        </Suspense>
      ),
    },
    {
      no: 3,
      listname: '모티너스 이용약관 및 개인정보처리방침 개정안내',
      day: '2022/07/14',
      cont: (
        <Suspense fallback={<LoadingModal zIndex={500} />}>
          <Notice3 />
        </Suspense>
      ),
    },
    {
      no: 2,
      listname: '잇클린 챌린지 건강선생 스프레드 상품 변경 공지 ',
      day: '2022/01/12',
      cont: (
        <Suspense fallback={<LoadingModal zIndex={500} />}>
          <Notice2 />
        </Suspense>
      ),
    },
    {
      no: 1,
      listname: '모티너스 이용약관 및 개인정보처리방침 개정안내',
      day: '2021/12/17',
      cont: (
        <Suspense fallback={<LoadingModal zIndex={500} />}>
          <Notice1 />
        </Suspense>
      ),
    },
  ]
  return (
    <MypageSetInner>
      <TitleHeader title={'공지사항'} borderbottom={'solid calc(100vw*(1/375)) #d5d5d5'} />
      <Setlistinner>
        {Data.map((value, index) => {
          return (
            <SetList
              key={`notice-list-item-no-${index}`}
              postNo={value.no}
              openOnDefault={value.no === defaultOpenNo ? true : false}
              listname={value.listname}
              day={value.day}
              cont={value.cont}
            />
          )
        })}
      </Setlistinner>
    </MypageSetInner>
  )
}

function SetList({ postNo, openOnDefault, listname, day, cont }) {
  const [showcont, setShowcont] = useState(false)
  useEffect(() => {
    if (openOnDefault) {
      setShowcont(true)
    }
  }, [openOnDefault])
  function clickShow() {
    setShowcont(!showcont)
  }
  return (
    <Setlistbox>
      <Noticelist onClick={clickShow}>
        <SetlistItem>
          <Setlistname>{listname}</Setlistname>
          <NoticeDay>{day}</NoticeDay>
        </SetlistItem>
      </Noticelist>
      {showcont ? <SetListCont>{cont}</SetListCont> : null}
    </Setlistbox>
  )
}

const MypageSetInner = styled.div`
  min-height: 100vh;
  height: auto;
  padding: calc(100vw * (51 / 375)) 0 calc(100vw * (60 / 375)) 0;
  // background: #f7f7f7;
`
const Setlistinner = styled.ul`
  // border-bottom: solid  calc(100vw*(12/375)) #f7f7f7;

  & > li:last-child {
    // border-bottom: 0;
  }
`
const Noticelist = styled.li`
  height: calc(100vw * (68 / 375));
  border-bottom: solid calc(100vw * (1 / 375)) #d8d8d8;
  padding: 0 calc(100vw * (17 / 375)) 0;
  background: #fff;
`
const SetlistItem = styled.span`
  display: grid;
  height: 100%;
  width: 100%;
  padding: calc(100vw * (16 / 375)) 0 calc(100vw * (16.5 / 375)) 0;
`
const Setlistname = styled.span`
  display: block;
  width: 100%;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  margin-bottom: calc(100vw * (3 / 375));
`
const NoticeDay = styled.span`
  display: block;
  width: 100%;
  font-size: calc(100vw * (10 / 375));

  text-align: left;
  color: #989898;
`
const SetListCont = styled.p`
  white-space: pre-wrap;
  font-size: calc(100vw * (10 / 375));
  line-height: 1.43;
  padding: calc(100vw * (18 / 375)) calc(100vw * (18 / 375)) calc(100vw * (25 / 375));

  border-bottom: solid calc(100vw * (1 / 375)) #d8d8d8;
`

const Setlistbox = styled.span`
  width: 100%;
`
